// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__q3Eyx","total":"Cart_total__WoYT3","actions":"Cart_actions__clqbV","button--alt":"Cart_button--alt__AzoI1","button":"Cart_button__lLygb"};